import React from "react";

interface CompassProps {
  angle: number;
  theme: string;
}

const CompassIcon = ({ angle, theme }: CompassProps) => {
  return (
    <div style={{ height: 20, width: 20, marginRight: 7 }}>
      <svg style={{ transform: `rotate(${angle+'deg'})` }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.038 3L9 10H11L10.038 3Z" fill={theme === "light" ? "black" : "white"} />
        <path
          d="M10 19.5C15.2467 19.5 19.5 15.2467 19.5 10C19.5 4.75329 15.2467 0.5 10 0.5C4.75329 0.5 0.5 4.75329 0.5 10C0.5 15.2467 4.75329 19.5 10 19.5Z"
          stroke={theme === "light" ? "black" : "white"}
          strokeMiterlimit="10"
        />
      </svg>
    </div>
  );
};

export default CompassIcon;
